export default "__VITE_ASSET__DT5_ApI0__"